import { useEffect, useRef, useState } from 'react';
import { getUser, getUserSync } from '../../../src/utils/utils';
import { getFavorite, handleFavoriteActivity, handleUnFavoriteActivity } from '../../../src/utils/requests';
import { useLocalStorage } from '../../../src/ui-components/hooks/useLocalStorage';
import { StyledOutlinedButton } from './HeaderSection';
import React from 'react';
import { useTranslation } from "next-i18next";
import { Favorite, FavoriteBorder } from "@mui/icons-material";

interface FavoriteDetailActivity {
  isFavorited: boolean;
}

function _FavoriteDetailActivity({ isProject, id, details }: { isProject: boolean; id: number; details: any }) {
  const { t } = useTranslation();
  const [favoriteState, setFavoriteState] = useState<FavoriteDetailActivity>({
    isFavorited: false,
  });
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [userInfo] = useLocalStorage<any>(`9asset.userinfo`);
  const isReloadNeedRef = useRef<boolean>(false);

  const handleLoginCancelled = () => {
    isReloadNeedRef.current = false;
    window.removeEventListener('login-cancelled', handleLoginCancelled);
    window.removeEventListener('logged-in', handleLoggedIn);
  };

  const handleLoggedIn = async () => {
    const user = userInfo || (await getUserSync());
    if (details?.user?.id === user?.id) {
      alert('You cannot contact your own listing');
    } else {
      applyFavirite(user);
    }
    window.removeEventListener('login-cancelled', handleLoginCancelled);
    window.removeEventListener('logged-in', handleLoggedIn);
  };

  useEffect(() => {
    async function effectWrapper() {
      const user = getUser();
      if (!user?.id) return;

      const { data } = await getFavorite(isProject ? 'project' : 'property', id, user.id);
      setFavoriteState({
        isFavorited: data?.isFavorited || false,
      });
    }
    effectWrapper();
  }, [details]);

  const applyFavirite = async (user: any) => {
    if (favoriteState.isFavorited) {
      await handleUnFavoriteActivity(isProject ? 'project' : 'property', id, user.id);
    } else {
      await handleFavoriteActivity(isProject ? 'project' : 'property', id, user.id);
    }

    setFavoriteState((prev) => ({
      isFavorited: !prev.isFavorited,
    }));
    buttonRef.current?.blur();
    isReloadNeedRef.current && window.location.reload();
  };

  return (
    <StyledOutlinedButton
      ref={buttonRef}
      onClick={async () => {
        try {
          const user = getUser();

          if (!user?.id) {
            isReloadNeedRef.current = true;
            const loginRequested = new CustomEvent('loginrequested');
            window.addEventListener('logged-in', handleLoggedIn);
            window.addEventListener('login-cancelled', handleLoginCancelled);
            window.dispatchEvent(loginRequested);
          } else {
            isReloadNeedRef.current = false;
            applyFavirite(user);
          }
        } catch (error) {
          console.error(error);
        }
      }}
      endIcon={favoriteState.isFavorited ? <Favorite className="icon" /> : <FavoriteBorder className="icon" />}
    >
      {t('favorite')}
    </StyledOutlinedButton>
  );
}

export const FavoriteDetailActivity = React.memo(_FavoriteDetailActivity);
